import React from "react";
import { Typography } from "@mui/material";

// The muted, centred line that lives in the composer slot: the AI disclaimer under the input, and
// the message that replaces the input once the conversation is closed. They were styled apart —
// 11px/#808080 against 14px/#888 with its own 16px box, the only #888 in the widget — so the same
// slot changed its voice and its spacing depending on state. It takes no style prop on purpose:
// the whole point is that both states look identical, and the slot's own padding is the parent's.
export default function ComposerNote({ children }) {
	return (
		<Typography
			variant="caption"
			sx={{
				display: "block",
				textAlign: "center",
				color: "#808080",
				fontSize: "11px",
				lineHeight: 1.5,
				mt: "6px",
			}}
		>
			{children}
		</Typography>
	);
}
